import React from 'react';
import { useSelector } from 'react-redux';
import { getGroupObject } from '../../Reducers/Configurator/Selectors';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { getSelectedAmounts } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors';

const getFirstSelectedAmount = (state) => Object.values(getSelectedAmounts(state.configurator) || {})[0] || 1;

const formatAvailability = (availableAmount, selectedAmount) => {
  if (availableAmount >= 10 && availableAmount >= selectedAmount) {
    return t('availability.available');
  }
  if (availableAmount < 10 || availableAmount < selectedAmount) {
    return t('availability.onlyFewLeft', { value: availableAmount });
  }
  return availableAmount;
};

const getAvailabilityColor = (availableAmount, selectedAmount) => {
  if (availableAmount >= selectedAmount) {
    return '#70a84d'; // green
  }
  return '#d03b22'; // red
};

export const Availability = ({ groupIdentifier, className, ...otherProps }) => {
  const { availability, amount = 1 } = useSelector((state) => getGroupObject(state, groupIdentifier));
  const setAmount = useSelector(getFirstSelectedAmount);
  const totalAmount = amount * setAmount;
  if (!availability) return null;
  return (
    <Typography
      className={className}
      {...otherProps}
      style={{ color: getAvailabilityColor(availability, totalAmount) }}
    >
      {formatAvailability(availability, totalAmount)}
    </Typography>
  );
};

Availability.propTypes = {
  groupIdentifier: PropTypes.string.isRequired,
  className: PropTypes.string,
};
